<template>
    <component :is="'h' + level" :class="headingClass">
        <slot />
    </component>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue';

// レベルに応じて適切なHTMLタグ（h1, h2, h3, h4）を使用
const props = defineProps<{
    level: 1 | 2 | 3 | 4;
}>();

// 見出しのクラス生成
const headingClass = computed(() => [
    'heading-common',
    `heading-h${props.level}`
]);
</script>

<style scoped lang="scss">
// 共通のスタイル
.heading-common {
    margin: 0 auto;
    color: #252522;
    font-style: normal;
    font-weight: 700;
}

// 各レベルの見出しスタイル
.heading-h1 {
    padding-bottom: 1.5rem;
    font-size: 1.5rem;
    line-height: 132%;
}

.heading-h2 {
    padding-bottom: 0.75rem;
    font-size: 1.25rem;
    line-height: 138%;
}

.heading-h3 {
    padding-bottom: 0.5rem;
    font-size: 1.125rem;
    line-height: 132%;
}

.heading-h4 {
    padding-bottom: 0.25rem;
    font-size: 1rem;
    line-height: 150%;
}

// PC用のスタイル
@include mixin.media(pc) {

    .heading-h1 {
        padding-bottom: 2.5rem;
        font-size: 2rem;
        line-height: 125%;
    }

    .heading-h2 {
        padding-bottom: 1rem;
        font-size: 1.5rem;
        line-height: 132%;
    }

    .heading-h3 {
        padding-bottom: 0.75rem;
        font-size: 1.25rem;
        line-height: 138%;
    }

    .heading-h4 {
        padding-bottom: 0.5rem;
        font-size: 1.125rem;
        line-height: 132%;
    }
}
</style>